<template>
    <div class="alert mb-3 p-2" @click="openAlert">
        <div class="d-flex align-items-center justify-content-start py-1">
            <p class="arrow no-select mb-0 me-2"
                :style="{transform: `rotateZ(${this.alertIsOpen ? '0deg' : '90deg'})`}">
                &#9654;
            </p>
            <p class="arrow mb-0"><strong>ATTENTION &#9888;</strong></p>
        </div>
        <div v-show="!alertIsOpen" class="message no-select">
            <div class="d-flex align-items-center py-1">
                <p class="mb-0">In case if you don't have API Key, do contact the 
                    <a @click.stop.prevent="navigateUrl">ADMIN</a>
                    to get your key and start accessing!
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            URL: 'mailto:savajava888@gmail.com',
        };
    },
    computed: {
        alertIsOpen(){
            return this.$store.getters.alertIsOpen;
        },
    },
    methods:{
        navigateUrl(){
            window.location.href = this.URL;
        },
        openAlert(){
            if(!this.alertIsOpen){
                return this.$store.dispatch('openAlert', true);
            }
            return this.$store.dispatch('openAlert', false);
        },
    },
}
</script>